import React, { Component } from "react";
import { EditHeadComponent } from "./../BioAndSubEditComponent";
import { connect } from "react-redux";
import { Col, Row, Modal } from "react-bootstrap";
import {
  EducationAndWorkPanel,
  EditEducationAndWorkPanel,
} from "./../../TutorSetting/BioAndSubEditComponent";
import { TutorSettingAction } from "./../../../redux/actions";
import ConfirmationModal from "./../../../components/modals/ConfirmationModal";
import { updateTutorSettings } from "../../../apis/tutors";

class EducationSetting extends Component {
  constructor() {
    super();
    this.state = {
      editMode: "",
      tutorSettingDataState: {},
      EditSpecificEdu: {
        schoolName: "",
        endDate: "",
        startDate: "",
        degree: "",
        isCurrent: false,
      },
    };
  }

  componentDidMount = () => {
    const { tutorSettingData } = this.props;
    var educationData = { ...tutorSettingData };
    educationData = educationData?.tutorDetails?.education?.sort(function (
      a,
      b
    ) {
      return new Date(b.startDate) - new Date(a.startDate);
    });
    this.setState({
      tutorSettingDataState: tutorSettingData,
      educationData: educationData?.length ? educationData : [],
    });
  };
  componentDidUpdate = (prevProps) => {
    const { tutorSettingData } = this.props;
    const { tutorSettingDataState } = this.state;
    if (
      (!tutorSettingDataState?.userId && tutorSettingData?.userId) ||
      prevProps?.tutorSettingData?.userId !== tutorSettingData?.userId
    ) {
      var educationData = { ...tutorSettingData };
      educationData = educationData?.tutorDetails?.education?.sort(function (
        a,
        b
      ) {
        return new Date(b.startDate) - new Date(a.startDate);
      });
      this.setState({
        tutorSettingDataState: tutorSettingData,
        educationData: educationData?.length ? educationData : [],
      });
    }
  };

  onCurrent = (index, rollStatus) => {
    const { EditSpecificEdu } = this.state;
    return (
      (EditSpecificEdu[rollStatus] = !EditSpecificEdu[rollStatus]),
      this.setState({
        EditSpecificEdu,
      })
    );
  };

  onTextChange = (e, add) => {
    const { EditSpecificEdu } = this.state;
    EditSpecificEdu[e.target.name] = e.target.value;

    this.setState({
      EditSpecificEdu,
      [`${add ? add : ""}${[e.target.name]}Req`]: true,
    });
  };
  onChangeDate = (date, index, dateType, add) => {
    const { EditSpecificEdu } = this.state;
    EditSpecificEdu[dateType] = date;
    this.setState({
      EditSpecificEdu,
      [`${add ? add : ""}${[dateType]}Req`]: true,
    });
  };
  onSave = (index) => {
    let { tutorSettingData } = this.props;
    let { educationData, EditSpecificEdu } = this.state;
    educationData[index] = EditSpecificEdu;
    tutorSettingData.tutorDetails.education = educationData;
    this.props.TutorSettingStoreData(tutorSettingData);
    let updateSettingParam = {
      updateSetting: {
        education: educationData,
      },
    };
    updateTutorSettings(updateSettingParam)
      .then((res) => {
        this.setState({
          loader: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loader: false,
        });
      });
    this.setState({
      selectedIndex: "",
    });
  };
  onCancel = () => {
    const { tutorSettingData } = this.props;
    var educationData = tutorSettingData?.tutorDetails?.education?.sort(
      function (a, b) {
        return new Date(b.startDate) - new Date(a.startDate);
      }
    );
    this.setState({
      educationData,
      selectedIndex: "",
    });
  };
  onRemove = (index) => {
    let { tutorSettingData } = this.props;
    tutorSettingData.tutorDetails.education.splice(index, 1);
    this.props.TutorSettingStoreData(tutorSettingData);
    let updateSettingParam = {
      updateSetting: {
        education: tutorSettingData?.tutorDetails?.education,
      },
    };
    updateTutorSettings(updateSettingParam)
      .then((res) => {
        this.setState({
          loader: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loader: false,
        });
      });
    this.setState({
      selectedIndex: "",
      confirmShow: false,
    });
  };

  AddEducationObj = () => {
    let { tutorSettingData } = this.props;
    let { educationData, EditSpecificEdu } = this.state;
    educationData.push(EditSpecificEdu);
    tutorSettingData.tutorDetails.education = educationData;
    this.props.TutorSettingStoreData(tutorSettingData);
    let updateSettingParam = {
      updateSetting: {
        education: educationData,
      },
    };
    updateTutorSettings(updateSettingParam)
      .then((res) => {
        this.setState({
          loader: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loader: false,
        });
      });
    this.setState({
      selectedIndex: "",
      isOpen: false,
    });
  };
  render() {
    const {
      EditSpecificEdu,
      selectedIndex,
      isOpen,
      educationData,
      confirmShow,
      schoolNameReq,
      degreeReq,
      addschoolNameReq,
      adddegreeReq,
      startDateReq,
      endDateReq,
      addstartDateReq,
      addendDateReq,
    } = this.state;

    return (
      <div className="flex-col-center">
        <EditHeadComponent
          settingTitle={"Education"}
          settingDescription={"Add your qualification and education."}
          buttonTitle={"Add education"}
          backToprofileView={() =>
            this.props.history.push("/tutor-dashboard/TutorSettingBioAndSub")
          }
          goTobutton={() =>
            this.setState({
              isOpen: true,
              EditSpecificEdu: {
                schoolName: "",
                endDate: "",
                startDate: "",
                degree: "",
                isCurrent: false,
              },
            })
          }
        />
        <Col
          lg={9}
          md={9}
          sm={12}
          xs={12}
          className="ProfileBio-of-setting-div"
        >
          <div style={{ marginBottom: "20px" }} />
          {educationData?.length
            ? educationData.map((edu, i) => (
                <div>
                  {selectedIndex === i &&
                  EditSpecificEdu.hasOwnProperty("schoolName") ? (
                    <EditEducationAndWorkPanel
                      firstInputHeadTitle="School / Unversity / Other institution"
                      secondInputHeadTitle="Qualification"
                      thirdInputHeadTitle="Degree classification or grade"
                      roleText="I am currently enrolled at this institution"
                      EditSpecificEduAndWork={EditSpecificEdu}
                      firstInputName="schoolName"
                      secondInputName="degree"
                      thirdInputName="grade"
                      firstInputReq={schoolNameReq}
                      secondInputReq={degreeReq}
                      startDateReq={startDateReq}
                      endDateReq={endDateReq}
                      firstInputError={
                        "Add school, university or other institution"
                      }
                      secondInputError={"Add qualification"}
                      current="isCurrent"
                      onCurrent={this.onCurrent}
                      onTextChange={this.onTextChange}
                      onChangeDate={this.onChangeDate}
                      index={i}
                      onCancel={this.onCancel}
                      onSave={this.onSave}
                      onRemove={() =>
                        this.setState({
                          confirmShow: true,
                        })
                      }
                      style={{
                        height: "65px",
                      }}
                    />
                  ) : (
                    <EducationAndWorkPanel
                      onEdit={() =>
                        this.setState({
                          EditSpecificEdu: { ...edu },
                          selectedIndex: i,
                        })
                      }
                      selectedIndex={selectedIndex}
                      head={`${edu.schoolName} . ${edu?.degree}`}
                      value={`${
                        edu.startDate
                          ? new Date(edu.startDate).getFullYear()
                          : ""
                      } - ${
                        edu.isCurrent
                          ? "present"
                          : edu.endDate
                          ? new Date(edu.endDate).getFullYear()
                          : ""
                      }`}
                      mode={"education"}
                    />
                  )}
                </div>
              ))
            : ""}
        </Col>
        <div style={{ marginBottom: "50px" }} />
        <AddEducationModal
          isOpen={isOpen}
          onHide={() =>
            this.setState({
              isOpen: false,
            })
          }
          firstInputReq={addschoolNameReq}
          secondInputReq={adddegreeReq}
          startDateReq={addstartDateReq}
          endDateReq={addendDateReq}
          EditSpecificEdu={EditSpecificEdu}
          onCurrent={this.onCurrent}
          onTextChange={(e) => this.onTextChange(e, "add")}
          onChangeDate={(date, index, dateType) =>
            this.onChangeDate(date, index, dateType, "add")
          }
          onCancel={this.onCancel}
          AddEducationObj={this.AddEducationObj}
        />
        <ConfirmationModal
          confirmShow={confirmShow}
          confirmonHide={() =>
            this.setState({
              confirmShow: false,
            })
          }
          onRemove={this.onRemove}
          modalMessage={"Are you sure you want to remove this education?"}
        />
      </div>
    );
  }
}

const AddEducationModal = ({
  isOpen,
  onHide,
  EditSpecificEdu,
  onCurrent,
  onTextChange,
  onChangeDate,
  onCancel,
  AddEducationObj,
  firstInputReq,
  secondInputReq,
  startDateReq,
  endDateReq,
}) => {
  console.log(startDateReq);
  console.log(endDateReq, "==");

  return (
    <div>
      <Modal
        size="lg"
        className="ProfileStatus-modal"
        show={isOpen}
        onHide={onHide}
      >
        <Modal.Body>
          <Row>
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ padding: "10px 40px", textAlign: "justify" }}
            >
              <div
                className="cancel-btn flex-center-center"
                onClick={onHide}
                style={{
                  fontSize: "17px",
                  width: "30px",
                  height: "30px",
                  marginTop: "20px",
                }}
              >
                <i className="mdi mdi-close"></i>
              </div>
              <div style={{ marginBottom: "50px" }} />
              <h4
                style={{
                  color: "#0f0f0f",
                  fontSize: "24px",
                  fontFamily: "CircularStd",
                }}
              >
                Add Education
              </h4>
              <div style={{ marginBottom: "30px" }} />
              <EditEducationAndWorkPanel
                firstInputHeadTitle="School / Unversity / Other institution"
                secondInputHeadTitle="Qualification"
                thirdInputHeadTitle="Degree classification or grade"
                roleText="I am currently enrolled at this institution"
                EditSpecificEduAndWork={EditSpecificEdu}
                firstInputName="schoolName"
                secondInputName="degree"
                thirdInputName="grade"
                firstInputReq={firstInputReq}
                secondInputReq={secondInputReq}
                startDateReq={startDateReq}
                endDateReq={endDateReq}
                firstInputError={"Add school, university or other institution"}
                secondInputError={"Add qualification"}
                current="isCurrent"
                onCurrent={onCurrent}
                onTextChange={onTextChange}
                onChangeDate={onChangeDate}
                onCancel={onCancel}
                AddObj={AddEducationObj}
                style={{
                  head: {
                    fontSize: "16px",
                    fontWeight: "400",
                  },
                  height: "45px",
                }}
                Addbtn={"Add"}
                ismodal={true}
              />
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  );
};

const mapDispatchToprops = (dispatch) => {
  return {
    TutorSettingStoreData: (payload) =>
      dispatch(TutorSettingAction.TutorSettingStoreData(payload)),
  };
};

const mapStateToProps = (state) => {
  const {
    TutorSettingReducer: { tutorSettingData },
  } = state;
  return {
    tutorSettingData,
  };
};

export default connect(mapStateToProps, mapDispatchToprops)(EducationSetting);
